<template>
  <v-footer app color="white" class="text-center footer">
    <v-row justify="center" no-gutters>
      <v-col cols="12" class="text-center">
        <div class="text-body-2 text-grey-darken-2">
          © {{ currentYear }} AquaFarm Pro - Fish Farm Management System
        </div>
        <div class="text-caption mt-1 text-grey">
          Version 1.0.0 | Built with Vue.js & Python FastAPI
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  border-top: 1px solid #e0e0e0;
  padding: 16px 0;
}
</style>